<gr-popover
  #popover
  [appendTo]="appendTo()"
  [styleClass]="popoverClasses()"
  (grHide)="grHide.emit()"
>
  <div class="gr-menu-list" [style.minWidth]="minWidth()">
    @if (header()) {
      <div class="gr-menu-header dropdown-header px-3.5 py-2 uppercase tracking-wider">
        {{ header() }}
      </div>
    }

    @for (item of items(); track item.label) {
      @if (item.routerLink) {
        <a
          class="dropdown-item gr-menu-item flex items-center gap-2 px-3.5 py-2 no-underline"
          [class.danger]="item.variant === 'danger'"
          [class.sm:hidden]="item.responsive === 'sm-down'"
          [class.xl:hidden]="item.responsive === 'xl-down'"
          [routerLink]="item.routerLink"
          [attr.aria-label]="item.ariaLabel ?? null"
          (click)="onItemClick(item)"
        >
          @if (item.icon) {
            <span class="material-icons-outlined" aria-hidden="true">{{ item.icon }}</span>
          }
          <span>{{ item.label }}</span>
        </a>
      } @else if (item.action) {
        <button
          type="button"
          class="dropdown-item gr-menu-item flex w-full cursor-pointer items-center gap-2 px-3.5 py-2 text-left"
          [class.danger]="item.variant === 'danger'"
          [class.sm:hidden]="item.responsive === 'sm-down'"
          [class.xl:hidden]="item.responsive === 'xl-down'"
          [attr.aria-label]="item.ariaLabel ?? null"
          (click)="onItemClick(item)"
        >
          @if (item.icon) {
            <span class="material-icons-outlined" aria-hidden="true">{{ item.icon }}</span>
          }
          <span>{{ item.label }}</span>
        </button>
      } @else if (item.href) {
        <a
          class="dropdown-item gr-menu-item flex items-center gap-2 px-3.5 py-2 no-underline"
          [class.danger]="item.variant === 'danger'"
          [class.sm:hidden]="item.responsive === 'sm-down'"
          [class.xl:hidden]="item.responsive === 'xl-down'"
          [href]="item.href"
          [attr.target]="item.href.startsWith('http') ? '_blank' : null"
          [attr.rel]="item.href.startsWith('http') ? 'noopener' : null"
          [attr.aria-label]="item.ariaLabel ?? null"
          (click)="onItemClick(item)"
        >
          @if (item.icon) {
            <span class="material-icons-outlined" aria-hidden="true">{{ item.icon }}</span>
          }
          <span>{{ item.label }}</span>
        </a>
      } @else {
        <button
          type="button"
          class="dropdown-item gr-menu-item flex w-full cursor-pointer items-center gap-2 px-3.5 py-2 text-left"
          [class.danger]="item.variant === 'danger'"
          [class.sm:hidden]="item.responsive === 'sm-down'"
          [class.xl:hidden]="item.responsive === 'xl-down'"
          [attr.aria-label]="item.ariaLabel ?? null"
          (click)="onItemClick(item)"
        >
          @if (item.icon) {
            <span class="material-icons-outlined" aria-hidden="true">{{ item.icon }}</span>
          }
          <span>{{ item.label }}</span>
        </button>
      }
      @if (item.divider) {
        <div
          class="gr-menu-divider my-1 h-px"
          [class.sm:hidden]="item.responsive === 'sm-down'"
          [class.xl:hidden]="item.responsive === 'xl-down'"
        ></div>
      }
    }

    <ng-content />
  </div>
</gr-popover>
